var h = Object.defineProperty;
var r = (i, t, e) => t in i ? h(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var n = (i, t, e) => r(i, typeof t != "symbol" ? t + "" : t, e);
import { BLOCK_TYPES as l } from "./constants.js";
class s {
  constructor(t = [], e = []) {
    n(this, "blocks");
    n(this, "stepsSinceLastChange");
    this.blocks = t, this.stepsSinceLastChange = e;
  }
  get onlyAttachmentListBlock() {
    return this.blocks.find((t) => t.type === l.ATTACHMENT_LIST);
  }
  get excludingAttachmentListBlock() {
    return new s(
      this.blocks.filter((t) => t.type !== l.ATTACHMENT_LIST),
      this.stepsSinceLastChange
    );
  }
  equals(t) {
    return t === this || JSON.stringify(t.blocks) === JSON.stringify(this.blocks);
  }
  append(t) {
    return t ? new s(this.blocks.slice(0).concat(t), this.stepsSinceLastChange) : new s(this.blocks.slice(0), this.stepsSinceLastChange);
  }
  appendMultiple(t) {
    let e = t.filter((c) => c !== null && typeof c !== "undefined");
    return e.length > 0 ? new s(
      this.blocks.slice(0).concat(e),
      this.stepsSinceLastChange
    ) : new s(this.blocks.slice(0), this.stepsSinceLastChange);
  }
}
export {
  s as BlocksDocument
};
